import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  materialityPlanningService,
  type CreatePlanBody,
  type MaterialityPlanningData,
  type UpdatePlanBody,
} from "../../services/materiality-planning.service";

export const planningKeys = {
  all: ["materiality-planning"] as const,
  data: () => [...planningKeys.all, "data"] as const,
};

export function useMaterialityPlanning() {
  return useQuery<MaterialityPlanningData, Error>({
    queryKey: planningKeys.data(),
    queryFn: () => materialityPlanningService.get(),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}

export function useCreatePlan() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: CreatePlanBody) => materialityPlanningService.create(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: planningKeys.data() });
    },
  });
}

export function useUpdatePlan() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: UpdatePlanBody }) =>
      materialityPlanningService.update(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: planningKeys.data() });
    },
  });
}

export function useDeletePlan() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => materialityPlanningService.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: planningKeys.data() });
    },
  });
}
